<template>
  <content-dashboard :hide="true" @pesquisar="load(1, $event)">
    <v-col>
      <v-card>
        <v-card-title class="subtitle-1">Filtros</v-card-title>
        <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" md="3" sm="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="filtro.codigo_agente"
                    label="Código do agente"
                    :rules="rules"/>
                </v-col>

                <v-col cols="12" md="3" sm="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="filtro.numero_remessa"
                    label="Número da remessa"/>
                </v-col>

                <v-col cols="12" md="3" sm="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="filtro.data_inicial"
                    label="Data Inicial"
                    type="date"
                    :rules="rules"/>
                </v-col>

                <v-col cols="12" md="3" sm="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="filtro.data_final"
                    label="Data Final"
                    type="date"
                    :rules="rules"/>
                </v-col>
              </v-row>  
            </v-form>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="load(1, filtro)">Pesquisar</v-btn>
          <v-btn color="primary" outlined class="ml-5" @click="reset">Limpar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <v-col v-if="status">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col>
              <p><strong>Agente:</strong>&nbsp;<i>{{ agente.nome }}</i></p>
              <p><strong>CPF:</strong>&nbsp;<i>{{ agente.cpf }}</i></p>
              <p><strong>E-mail:</strong>&nbsp;<i>{{ agente.email }}</i></p>
              <p><strong>Matrícula:</strong>&nbsp;<i>{{ agente.matricula }}</i></p>
              <p><strong>Unidade Autuadora:</strong>&nbsp;<i>{{ agente.unidade_autuadora }}</i></p>
            </v-col>

            <v-col>
              <p><strong>Quantidade de Imagens Validadas:</strong>&nbsp;
                <i>{{ quantidade_registros_validos }}</i>&nbsp;
                <i class="fas fa-check-circle" style="color: green;"></i>
              </p>

              <p><strong>Quantidade de Imagens Invalidadas:</strong>&nbsp;
                <i>{{ quantidade_registros_invalidos }}</i>&nbsp;
                <i class="fas fa-minus-circle" style="color: red;"></i>
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </content-dashboard>
</template>

<script>

import { mapState } from "vuex";
import queryString from "querystring";
import urlApi from "@/routes/urlApi";
import { showError } from "@/global";

export default {

  computed: mapState("user", ["permissoes"]),

  data() {
    return {
      loading: false,
      valid: true,
      rules: [v => !!v || "Este campo é Obrigatório"],
      filtro: {},
      msg: "",
      agente: [],
      quantidade_registros_validos: 0,
      quantidade_registros_invalidos: 0,
      status: false
    };
  },

  methods: {
    reset() {
      this.filtro = {};
    },

    load(page = 1, filtro) {
      if (!this.permissoes.relatorio_analises_imagens) {
        this.msg = "Você não possui permissão";
        return;
      }

      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.$store.commit("overlay/toggle", true);

      const filter = queryString.stringify(filtro);
      const url = `${urlApi}/relatorio/analise-imagem?page=${page}&${filter}`;
      
      this.$http.get(url).then(res => {

        this.agente = res.data.dados.agente;
        this.quantidade_registros_validos = res.data.dados.quantidade_registros_validos;
        this.quantidade_registros_invalidos = res.data.dados.quantidade_registros_invalidos;
        this.status = res.data.status;

        this.loading = false;
        this.$store.commit("overlay/toggle", false);
      }).catch(error => {

        this.loading = false;
        this.$store.commit("overlay/toggle", false);
        this.status = error.body.status;

        showError(error.body.message);
      });
    }
  },

  mounted() {
    this.load();
  }
}

</script>